"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var environments_1 = require("./environments");
exports.useImpersonationAccessToken = function (props) {
    var _a = react_1.default.useState({}), state = _a[0], setState = _a[1];
    var shouldFetch = !props.skip && !!props.subjectId;
    react_1.default.useEffect(function () {
        var aborted = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, response, responseData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!shouldFetch) {
                            return [2 /*return*/];
                        }
                        data = new FormData();
                        data.append("subject_id", props.subjectId);
                        data.append("grant_type", "impersonation");
                        data.append("client_id", props.clientId);
                        data.append("actor_token", props.accessToken);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(environments_1.environmentSettings[props.environment].url + "/connect/token", {
                                method: "POST",
                                body: data
                            })];
                    case 2:
                        response = _a.sent();
                        if (aborted) {
                            return [2 /*return*/];
                        }
                        if (response.status >= 400) {
                            setState({ error: "impersonation_failed" });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        if (aborted) {
                            return [2 /*return*/];
                        }
                        setState({
                            accessToken: responseData.access_token
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        if (aborted) {
                            return [2 /*return*/];
                        }
                        setState({ error: "network_error" });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            aborted = true;
        };
    }, [props.accessToken, props.subjectId, props.skip, props.clientId, props.environment, shouldFetch]);
    // Set state directly to avoid bugs when loading is switched later in effect
    var previousSubjectId = react_1.default.useRef();
    if (props.subjectId !== previousSubjectId.current) {
        previousSubjectId.current = props.subjectId;
        setState({
            loading: shouldFetch
        });
    }
    else if (state.loading && !shouldFetch) {
        setState({
            loading: false
        });
    }
    return state;
};
//# sourceMappingURL=impersonation.js.map